import { render, staticRenderFns } from "./CategoriesFrame.vue?vue&type=template&id=575b91d2&"
import script from "./CategoriesFrame.vue?vue&type=script&lang=js&"
export * from "./CategoriesFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports